import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetHourlyTuitionBillingResponse {
  _id: string;
  name: string;
  studioId: string;
  ranges: Array<Range>;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface Range {
  _id: string;
  minMinute: number;
  maxMinute: number;
  flatRate: number;
}

export const getHourlyTuitionBilling = async () => {
  const response = await baseAPI.get<Array<GetHourlyTuitionBillingResponse>>(
    'hourly-tuition-billing',
  );
  return response.data;
};

export const useGetHourlyTuitionBilling = () => {
  return useQuery({
    queryKey: [KEYS.HOURLY_TUITION_BILLING],
    queryFn: () => getHourlyTuitionBilling(),
    // enabled: !!params.invoiceId,
  });
};
